import {filter, reduce} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {precisionCalculation} from 'shared/web';

import {DeliveryNoteItem} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

export function calculateTotalPrices(items: DeliveryNoteItem[]) {
  const selectedItems = filter((item: DeliveryNoteItem) => item.isSelected)(items);

  const withoutVat = reduce((acc, item: DeliveryNoteItem) => {
    if (isNotNil(item.totalPrice) && item.totalPrice > 0) {
      return precisionCalculation.add(acc, item.totalPrice);
    }
    return acc;
  }, 0)(selectedItems);

  const withVat = reduce((acc, item: DeliveryNoteItem) => {
    if (isNotNil(item.totalPriceWithVat) && item.totalPriceWithVat > 0) {
      return precisionCalculation.add(acc, item.totalPriceWithVat);
    }
    return acc;
  }, 0)(selectedItems);

  return {
    withoutVat,
    withVat,
  };
}
